// extracted by mini-css-extract-plugin
module.exports = {"fixtureSummaryBlock":"fixtureSummaryBlock_fixtureSummaryBlock__dVSVE"};